import { createAsyncThunk } from '@reduxjs/toolkit';

export const createMemberEmail = createAsyncThunk(
  'users/memberEmail/create',
  async ({ memberId }, { extra: { gccApiClient } }) => {
    const { memberEmail: email } = await gccApiClient.createMemberPromoEmail(memberId);
    return { memberId, email };
  },
);
